import React from "react";
import { SITE } from "../content";
import { Breadcrumbs } from "../components/Layout";
import { Reveal } from "../components/Motion";

export default function KontakPage() {
  return (
    <>
      <section className="page-head" data-testid="kontak-head">
        <Breadcrumbs current="Kontak" />
        <h1 className="page-head__title">Sapa kami</h1>
        <p className="page-head__lede">
          Untuk pertanyaan seputar menu atau kedai, cara terbaik adalah menelepon atau datang
          langsung. Kami belum mencantumkan layanan pesan antar resmi.
        </p>
      </section>

      <section className="section">
        <div className="info-grid">
          <Reveal className="info-card">
            <p className="info-card__label">Telepon</p>
            <a href={SITE.phoneHref} className="info-card__value" data-testid="kontak-cta-telepon">
              {SITE.phoneDisplay}
            </a>
            <p className="info-card__sub">Selama jam buka, 10.00–22.00 WIB</p>
          </Reveal>
          <Reveal className="info-card" delay={0.08}>
            <p className="info-card__label">Kunjungi Kedai</p>
            <p className="info-card__value">{SITE.address.street}</p>
            <p className="info-card__sub">
              {SITE.address.area}, {SITE.address.city}
            </p>
          </Reveal>
          <Reveal className="info-card" delay={0.16}>
            <p className="info-card__label">Jam Buka</p>
            <p className="info-card__value">Setiap Hari</p>
            <p className="info-card__sub">10.00–22.00 WIB, Senin sampai Minggu</p>
          </Reveal>
        </div>
      </section>

      <section className="section band">
        <Reveal>
          <p className="section__eyebrow">Catatan Kecil</p>
          <h2 className="band__address">
            Semangkuk bakmi paling nikmat disantap hangat, langsung di kedai.
          </h2>
          <div className="band__ctas">
            <a href={SITE.phoneHref} className="btn btn--seal" data-testid="kontak-band-cta-telepon">
              Telepon Sekarang
            </a>
          </div>
        </Reveal>
      </section>
    </>
  );
}
